import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ExpandableListItem, Icon, ListItem, Tooltip } from '@optimus-web/core';
import SidebarModalNavigatedLink from './SidebarModalNavigatedLink';

export const LinkListItem = createLink(SidebarModalNavigatedLink);

export const SidebarFontIcon = styled(Icon).attrs({
    variant: 'basic',
})``;

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const ListItemWithTooltip = Tooltip(forwardRef((props, ref) => <ListItem {...props} innerRef={ref} />));

export const SidebarExpandableListItem = ExpandableListItem;
SidebarExpandableListItem.defaultProps = {
    ...SidebarExpandableListItem.defaultProps,
    // @ts-expect-error The factory hides away the props. Remove the factory on ExpandableListItem to resolve this
    dense: false,
};

export const SidebarContentWrapper = styled.div`
    padding: 32px 0 56px;
`;
